<template>
  <div v-show="isShowGroup">
    <transition name="media-scale">
      <div>
        <el-dialog
          :title="$t('group.分组控制')"
          width="760px"
          :visible="isShowGroup"
          class="dialog-dark"
          @close="onClose"
        >
          <div
            class="group scrollbar"
            v-if="!join"
            :class="{ 'no-group-content': groups.length === 0 }"
            @scroll="load"
            ref="scrollInfinite"
          >
            <div
              class="group-item"
              v-for="(item, index) of groups"
              :key="index"
            >
              <div
                class="group-item-title"
                @click="changeOpen(item.groupId, item.userCount)"
              >
                <p class="group-item-name">
                  <icon
                    name="open"
                    class="group-item-close"
                    scale="30"
                    :class="{ 'group-item-open': item.open }"
                  ></icon>
                  <span class="group-item-id">
                    <img
                      :src="require('@/svg/group/group-icon.svg')"
                      width="10px"
                    />{{ item.groupNumber }}</span
                  >
                  <span class="fontColor">{{ item.groupName }}</span
                  ><span v-if="item.userCount > 0" class="group-item-count"
                    >（<i>{{ item.userCount }}</i
                    >{{ $t("group.人") }}）</span
                  >
                  <span v-if="item.userCount === 0" class="group-item-count"
                    >（{{ $t("group.暂无观众") }}）</span
                  >
                </p>
                <!-- <a
                  href="javascript:;"
                  class="group-item-join"
                  v-if="!loadingJoin"
                  @click.stop="joinGroup(item)"
                  >{{ $t("group.加入") }}</a
                > -->
                <a
                  href="javascript:;"
                  class="group-item-join"
                  v-if="loadingJoin && joinId == item.groupId"
                  >{{ $t("group.加入中") }}</a
                >
                <a
                  href="javascript:;"
                  class="group-item-join"
                  v-else
                  @click.stop="joinGroup(item)"
                  >{{ $t("group.加入") }}</a
                >
              </div>
              <ul v-if="item.open" class="group-item-content">
                <li
                  class="group-item-content-li"
                  v-for="(user, index) of item.users"
                  :key="index"
                >
                  <span class="group-item-content-li-name">
                    <img
                      :src="user.headImgUrl"
                      v-if="user.headImgUrl"
                      width="20"
                      height="20"
                    />
                    <img
                      v-else-if="
                        user.role && ['6', '7', '8'].includes(user.role + '')
                      "
                      :src="require('@/svg/chatavatar_' + user.role + '.svg')"
                      width="20"
                      height="20"
                    />
                    <img
                      v-else
                      :src="require('@/svg/default_chatavatar.svg')"
                      width="20"
                      height="20"
                    /><span>{{ user.nickName }}</span
                    ><span v-if="user.uid == userInfo.uid"
                      >（{{ $t("group.我") }}）</span
                    >
                  </span>
                </li>
              </ul>
            </div>
            <div v-if="groups.length === 0">
              <img
                :src="require('@/assets/images/blank/blank.png')"
                width="192px"
              />
              <p class="no-group">{{ $t("group.暂无分组") }}</p>
            </div>
          </div>
          <div
            class="group scrollbar"
            v-if="join"
            @scroll="load"
            ref="scrollInfinite"
          >
            <div class="group-item">
              <div class="group-item-title">
                <p class="group-item-name">
                  <span class="group-item-id">
                    <img
                      :src="require('@/svg/group/group-icon.svg')"
                      width="10px"
                    />{{ groupJoin.groupNumber }}</span
                  >
                  <span class="fontColor">{{ groupJoin.groupName }}</span
                  ><span class="group-item-count"
                    >（<i>{{ groupJoin.count }}</i
                    >{{ $t("group.人") }}）</span
                  >
                </p>
                <a href="javascript:;" class="group-item-disabled">{{
                  $t("group.已加入")
                }}</a>
              </div>
              <ul class="group-item-content">
                <li
                  class="group-item-content-li"
                  @mouseenter="showQuite = true"
                  @mouseleave="showQuite = false"
                  v-for="(user, index) of groupJoin.users"
                  :key="index"
                >
                  <span class="group-item-content-li-name">
                    <img
                      :src="user.headImgUrl"
                      v-if="user.headImgUrl"
                      width="20"
                      height="20"
                    />
                    <img
                      v-else-if="
                        user.role && ['6', '7', '8'].includes(user.role + '')
                      "
                      :src="require('@/svg/chatavatar_' + user.role + '.svg')"
                      width="20"
                      height="20"
                    />
                    <img
                      v-else
                      :src="require('@/svg/default_chatavatar.svg')"
                      width="20"
                      height="20"
                    />
                    <span class="fontColor">{{ user.nickName }}</span>
                    <span v-if="user.uid == userInfo.uid" class="fontColor"
                      >（{{ $t("group.我") }}）</span
                    >
                  </span>
                  <!-- <a
                    href="javascript:;"
                    class="group-item-quite"
                    @click.stop="quiteGroup(groupJoin)"
                    v-if="role==3 && user.uid != userInfo.uid && showQuite"
                    >{{$t('group.踢出')}}</a
                  > -->
                </li>
              </ul>
            </div>
          </div>
          <div class="group-control" v-if="join">
            <a href="javascript:;" class="group-quite" @click="leaveGroup">{{
              $t("group.离开讨论组")
            }}</a>
          </div>
        </el-dialog>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Role from "@/mixins/role";
import { getParameter } from "@/utils/global";
import { getGroupList, getGroupUsers } from "@/api/liveRequest/group";
import { pushRoomControlFunc } from "@/utils/socketMessageDispose";

export default {
  name: "Group",
  components: {},
  mixins: [Role],
  data() {
    return {
      //open: false,
      showQuite: false,
      appId: "cloud_webcast",
      groups: [],
      join: false,
      groupJoin: null,
      count: 2000,
      sortId: 0,
      openGroupId: "0",
      usersLen: 0,
      groupName: "",
      loadingJoin: false,
      joinId: ""
    };
  },
  computed: {
    ...mapGetters([
      "isShowGroup",
      "userInfo",
      "liveToken",
      "rtcClient",
      "chatRoomId",
      "teamId",
      "groupOrder",
    ]),
    role() {
      //3:主播 2：助手 1：嘉宾
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.type
      );
    },
  },
  watch: {
    isShowGroup: {
      handler(value) {
        if (value) {
          if (this.join) {
            this.changeOpen(this.teamId, 1);
          } else {
            this.getGroupList();
          }
        }
      },
    },
  },
  mounted() {
    pushRoomControlFunc((msg) => {
      this.getCvMcRoomMessage(msg);
    });
  },
  methods: {
    /**
     * 获取组列表
     */
    async getGroupList() {
      // let params = {
      //   webcastId : getParameter("liveId")
      // };
      const { code, data } = await getGroupList(
        getParameter("liveId"),
        this.$store.getters.liveToken
      );
      console.log(data, code);
      if (code == 200) {
        this.groups = data.groupInfos;
      }
    },
    // 关闭弹窗
    onClose() {
      this.$store.commit("SET_SHOW_GROUP", false);
    },
    /**
     * 打开讨论组
     */
    async changeOpen(id, count) {
      console.log(count, "vvvv");
      if (count > 0) {
        this.openGroupId = id;
        let params = {
          count: this.count,
          sortId: this.sortId,
          group_id: id,
        };
        let { data } = await getGroupUsers(
          id,
          params,
          this.$store.getters.liveToken
        );
        this.groups.forEach((item) => {
          if (id == item.groupId) {
            item.open = item.open ? !item.open : true;
            item.users = data.userState;
            item.count = data.count;
            this.groupJoin = item;
            console.log(this.groupJoin, "groupJoin");
          }
        });
        console.log(this.groups, "groups");
        let userBottom = data.userState;
        let len = userBottom.length;
        this.sortId = len > 2000 ? userBottom[len - 1].sortId : 0;
        this.usersLen = data.userState.length;
        console.log(userBottom.length, "userState");
        this.$forceUpdate();
      }
    },
    /**
     * 加入讨论组
     */
    joinGroup(item) {
      this.groupName = item.groupName;

      this.loadingJoin = true;
      this.$confirm(this.$t('group.加入讨论组') + item.groupName,
      this.$t('group.提示'),
      {
        confirmButtonText: this.$t('group.确定'),
        cancelButtonText: this.$t('group.取消'),
      })
        .then(() => {
          //this.loadingJoin = false;
          this.$store.commit("SET_FIRSTINIT", true);
          this.rtcClient.RTMSession.CcWebSocket.joinCvMcRoom(
            {
              room_id: this.chatRoomId,
              msg: this.$t('group.请求进入房间'),
              team_id: item.groupId,
            },
            this.appId
          );
          this.$store.commit("SET_GROUP_ORDER", item.groupNumber);
          this.joinId = item.groupId;
          setTimeout(() => {
            this.$store.commit("SET_FIRSTINIT", false);
            if (this.loadingJoin) {
              this.loadingJoin = false;
              this.$message({
                type: "error",
                message: this.$t('group.加入讨论组') + item.groupName + this.$t('group.失败'),
              });
              this.joinId = ""
            }
          }, 20000);
        })
        .catch(() => {
          this.loadingJoin = false;
          this.$store.commit("SET_FIRSTINIT", false);
          // this.$message({
          //   type: "error",
          //   message: "加入讨论组" + item.groupName + "失败",
          // });
        });
    },
    quiteGroup() {
      this.$confirm(this.$t('group.退出讨论组'), this.$t('group.提示'), {
        confirmButtonText: this.$t('group.确定'),
        cancelButtonText: this.$t('group.取消'),
      })
        .then(() => {})
        .catch(() => {});
    },
    leaveGroup() {
      this.$confirm(
        this.$t('group.确定离开讨论组') + this.groupName + "，" + this.$t('group.回到主会场') + "？",
        this.$t('group.提示'),
        {
          confirmButtonText: this.$t('group.确定'),
          cancelButtonText: this.$t('group.取消'),
        }
      )
        .then(() => {
          this.$store.commit("SET_FIRSTINIT", true);
          this.rtcClient.RTMSession.CcWebSocket.joinCvMcRoom(
            {
              room_id: this.chatRoomId,
              msg: this.$t('group.请求进入房间'),
              team_id: 0,
            },
            this.appId
          );
          this.$message({
            type: "success",
            message: this.$t('group.您已返回至主会场'),
          });
          setTimeout(() => {
            this.$store.commit("SET_FIRSTINIT", false);
          }, 20000);
        })
        .catch(() => {
          setTimeout(() => {
            this.$store.commit("SET_FIRSTINIT", false);
          }, 20000);
        });
    },
    getCvMcRoomMessage(msg) {
      console.log(msg, "msg...............");
      switch (msg.cmd) {
        case 6105: {
          if (msg.requestData.status == 200) {
            //this.getGroupList();
            console.log(msg.requestData.team_id, "team_id");
            this.openGroupId = msg.requestData.team_id;
            this.$store.commit("SET_GROUP_ID", msg.requestData.team_id);
            if (msg.requestData.team_id != "0") {
              this.join = true;
              setTimeout(() => {
                this.changeOpen(msg.requestData.team_id, 1);
              }, 1000);
              this.$message({
                type: "success",
                message: this.$t('group.您已加入讨论组') + this.groupName,
              });
              this.joinId = "";
            } else {
              this.join = false;
              //this.groupOrder = "";
              this.$store.commit("SET_GROUP_ORDER", "");
              this.getGroupList();
            }
          } else {
            //this.groupOrder = "";6055 分组已满 201 不允许加入
            this.$message({
              type: "error",
              message: this.$t('group.小组人数达到最大限制'),
            });
            this.$store.commit("SET_GROUP_ORDER", "");
          }
          this.loadingJoin = false;
          break;
        }
      }
    },
    load() {
      const scrollInfinite = this.$refs.scrollInfinite;
      const elementHeight = scrollInfinite.getBoundingClientRect().height;
      const scrollTop = scrollInfinite.scrollTop;
      const scrollHeight = scrollInfinite.scrollHeight;

      if (Math.ceil(scrollTop) + Math.ceil(elementHeight) + 5 >= scrollHeight) {
        if (this.usersLen === 2000) {
          this.changeOpen(this.openGroupId, 1);
        }
        console.log(this.sortId, "滚动");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.media-scale {
  opacity: 1;
  transition: all 0s;
}
.media-scale-enter,
.media-scale-leave-to {
  opacity: 0;
  width: 0;
}
.group {
  min-height: 400px;
  max-height: 460px;
  overflow-y: auto;
  &-item {
    &-title {
      display: flex;
      align-items: center;
      height: 50px;
      cursor: pointer;
    }
    &-name {
      flex: 1;
      text-align: left;
    }
    border: 1px solid #444767;
    border-radius: 2px;
    padding: 0 20px;
    margin-bottom: 10px;
    &-join,
    &-quite {
      color: $bule-color;
      text-decoration: none;
      &:hover,&:active,&:visited {
        color: $bule-color;
      }
      text-align: right;
    }
    &-disabled {
      color: #acb2bf;
      text-decoration: none;
      text-align: right;
    }
    &-close {
      width: 8px;
      height: 14px;
      margin-right: 5px;
    }
    &-open {
      transform: rotate(90deg);
    }
    &-content {
      padding: 0 15px 20px 15px;
      &-li {
        display: flex;
        height: 30px;
        align-items: center;
        &-name {
          flex: 1;
          text-align: left;
          align-items: center;
          display: flex;
          img {
            margin-right: 6px;
            border-radius: 20px;
          }
        }
      }
    }
    &-count {
      color: #acb2bf;
    }
    &-id {
      width: 50px;
      height: 16px;
      background: #4064a6;
      border-radius: 37px;
      display: inline-block;
      margin-right: 6px;
      text-align: center;
      line-height: 16px;
      font-size: 10px;
      img {
        margin-right: 6px;
      }
    }
  }
  &-quite {
    width: 100px;
    height: 28px;
    line-height: 28px;
    background: rgba(222, 53, 61, 0.1);
    border-radius: 6px;
    border: 1px solid rgba(222, 53, 61, 0.5);
    color: $quite-group-color;
    text-decoration: none;
  }
  &-control {
    display: flex;
    justify-content: flex-end;
  }
}
.no-group {
  color: #acb2bf;
  &-content {
    border-top: 0 none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  margin-top: 10px;
}
::v-deep .el-dialog__body {
  padding: 20px;
}
</style>
